<script lang="ts" setup>
import { computed } from 'vue';
import { Menu } from '~/types';
import ExternalLinkWarning from '~/components/ui/ExternalLinkWarning.vue';
import Image from '~/components/ui/Image.vue';

interface Props {
  item: Menu.MenuItem;
  level?: number;
}

const props = withDefaults(defineProps<Props>(), { level: 0 });

const levelCssClass = computed<string>(() => `menu-item--level-${props.level}`);
</script>

<template>
  <li v-if="item.data?.image?.src" class="menu-item" :class="levelCssClass">
    <a
      :href="item.value || '#'"
      :target="item.target || '_blank'"
      :role="!item.value ? 'button' : undefined"
      class="menu-item__link"
    >
      <span class="sr-only">{{ item.name }}</span>
      <Image :image="item.data.image" class="menu-item__image" />
      <ExternalLinkWarning :target="item.target" />
    </a>
  </li>
</template>
